import React from "react";
import { steps } from "../data/content";
import { Accent, SectionHeading } from "./ui/SectionHeading";
export function Steps() {
  return <section className="bg-blush px-4 py-14 sm:px-6 sm:py-20" data-id="element-158" data-mp="18dbhocmiore4">
      <SectionHeading title={<>
            La tua prima creazione,
            <span className="block" data-id="element-160" data-mp="yni79ey42ibg">
              <Accent italic data-id="element-161" data-mp="ymqjgqar9ovq">a tre passi da te.</Accent>
            </span>
          </>} data-id="element-159" data-mp="unhstub0i74e" />
      <ol className="mx-auto mt-10 grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-162" data-mp="kn7eu7h5kvo6">
        {steps.map(({
        icon: Icon,
        title,
        body
      }, i) => <li key={title} className="flex flex-col rounded-[28px] border border-line bg-cream p-6 shadow-[0_14px_30px_-24px_rgba(86,18,54,0.45)] sm:p-7" data-id="element-163" data-mp="bnu5rfwxy93z" data-mpi={i}>
            <Icon className="mx-auto h-12 w-12 text-rose" strokeWidth={1} aria-hidden="true" data-id="element-164" data-mp="fr8uqw2uxztk" />
            <h3 className="mt-6 font-serif text-[24px] font-semibold leading-tight text-wine" data-id="element-165" data-mp="2600s9avaccbl">
              <span className="text-rose" data-id="element-166" data-mp="2a1ch3e6c4tiq">{i + 1}.</span> {title}
            </h3>
            <p className="mt-3 text-[15px] leading-relaxed text-ink sm:text-base" data-id="element-167" data-mp="1q9izwdigu4yj">{body}</p>
          </li>)}
      </ol>
    </section>;
}